import { render, staticRenderFns } from "./AddressTable.vue?vue&type=template&id=62959378&scoped=true&"
import script from "./AddressTable.vue?vue&type=script&lang=js&"
export * from "./AddressTable.vue?vue&type=script&lang=js&"
import style0 from "./AddressTable.vue?vue&type=style&index=0&id=62959378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62959378",
  null
  
)

export default component.exports